import Constants from '@/Constants';
import { Feedback } from '@/models/User';
import { ApplicationState } from '@/store';
import { postFeedbackClear, postFeedbackRequest } from '@/store/user/action';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './style.scss';

const SendFeedback = () => {
    const [feedback, setFeedback] = useState('');
    const [showMessage, setShowMessage] = useState(false);
    const [showErrorMessage, setShowErrorMessage] = useState(false);

    const { data: strings } = useSelector((state: ApplicationState) => state.locale);
    const { success, hasError } = useSelector((state: ApplicationState) => state.users);

    const dispatch = useDispatch();

    useEffect(() => {
        if (success) {
            setShowMessage(true);
            setFeedback('');
        } else {
            setShowMessage(false);
        }
    }, [dispatch, success]);

    useEffect(() => {
        if (hasError) {
            setShowErrorMessage(true);
        } else {
            setShowErrorMessage(false);
        }
    }, [hasError]);

    useEffect(() => {
        dispatch(postFeedbackClear());
    }, [dispatch]);

    const handleSubmit = () => {
        const payload: Feedback = {
            htmlBody: feedback,
            subject: Constants.FEEDBACK_EMAIL_SUBJECT,
        } as Feedback;

        dispatch(postFeedbackRequest(payload));
    };

    return (
        <>
            <div className="row input-section">
                <div className="title-container">
                    <h1>{strings.WRITE_YOUR_MESSAGE}</h1>
                </div>
                <textarea
                    className="form-control"
                    id="titleInput"
                    onChange={(e) => setFeedback(e.target.value)}
                    placeholder={strings.YOUR_FEEDBACK}
                    value={feedback || ''}
                />
            </div>
            <div className={`message ${showMessage ? 'success' : ''} ${showErrorMessage ? 'error' : ''}`}>
                <i className="material-icons align-middle">
                    {`${showMessage ? 'check_circle' : ''}`}
                    {`${showErrorMessage ? 'error' : ''}`}
                </i>
                <span>
                    {`${showMessage ? strings.FEEDBACK_SUCCESS : ''}`}
                    {`${showErrorMessage ? strings.FEEDBACK_FAILURE : ''}`}
                </span>
            </div>
            <div className="modal-confirm-button">
                <button className="btn btn-secondary confirm-button" disabled={feedback.length === 0} onClick={handleSubmit} type="button">
                    {strings.SEND_FEEDBACK}
                </button>
            </div>
        </>
    );
};

export default SendFeedback;
